<div class="fb-root">

  <div class="fb-success" *ngIf="saved">
    <div class="fb-success__card">
      <div class="fb-success__icon">
        <mat-icon>check_circle</mat-icon>
      </div>      
      <h2>{{ 'FORM_BUILDER.SAVED_TITLE' | translate }}</h2>
      <p>{{ 'FORM_BUILDER.SAVED_BODY' | translate }}</p>
      <div class="fb-success__actions">
        <button type="button" class="fb-btn fb-btn--primary" (click)="emitClose(true)">
          {{ 'FORM_BUILDER.BACK_LIST' | translate }}
        </button>
        <button type="button" class="fb-btn fb-btn--ghost" (click)="resetBuilder()">
          {{ 'FORM_BUILDER.CREATE_ANOTHER' | translate }}
        </button>
      </div>
    </div>
  </div>


  <div class="fb-appbar">
    <button class="fb-btn fb-btn--ghost-light btn-header-oscuro"
            (click)="emitClose(false)">
      ← {{ 'COMMON.BACK' | translate }}
    </button>            
    <div class="fb-appbar__title">
      {{ editingId ? ('FORM_BUILDER.EDIT' | translate) : ('FORM_BUILDER.NEW' | translate) }}
    </div>
    <div class="fb-appbar__spacer"></div>
    <div class="fb-appbar__step-indicator">
      {{ 'FORM_BUILDER.STEP_OF' | translate:{current: currentStep + 1, label: stepLabel} }}
    </div>
  </div>

  <div class="fb-body">

    <aside class="fb-panel fb-panel--left">
      <div class="fb-stepper">
        <div class="fb-step"
             *ngFor="let label of stepLabels; let i = index"
             [class.fb-step--active]="isStepActive(i)"
             [class.fb-step--completed]="isStepCompleted(i)"
             [class.fb-step--clickable]="isStepCompleted(i) || (i === 0)"
             (click)="goToStep(i)">
          <div class="fb-step__dot">
            <span *ngIf="isStepCompleted(i)">✓</span>
            <span *ngIf="!isStepCompleted(i)">{{ i + 1 }}</span>
          </div>
          <div class="fb-step__label">{{ label }}</div>
        </div>
      </div>

      <div class="fb-hint" *ngIf="currentStep === 0">
        {{ 'FORM_BUILDER.HINT0' | translate }}
      </div>

      <div class="fb-tree" *ngIf="currentStep === 1">
        <div class="fb-tree__header">
          <span class="fb-tree__title">{{ 'FORM_BUILDER.TABS' | translate }}</span>
          <div class="fb-tree__actions">
            <button type="button" class="fb-icon-btn" [title]="'FORM_BUILDER.COPY_TAB' | translate"
                    (click)="openCopiarPestania()">⧉</button>
            <button type="button" class="fb-icon-btn" [title]="'FORM_BUILDER.NEW_TAB' | translate"
                    (click)="addPestania()">+</button>
          </div>
        </div>

        <div *ngIf="pestanias.length === 0" class="fb-tree__empty">
          <p>{{ 'FORM_BUILDER.NO_TABS' | translate }}</p>
        </div>

        <div class="fb-tree__tabs"
             cdkDropList
             (cdkDropListDropped)="onPestaniaDrop($event)">
        <div class="fb-tab"
             *ngFor="let pest of pestanias.controls; let pestIndex = index"
             cdkDrag
             [cdkDragDisabled]="pestanias.length < 2"
             [class.fb-tab--selected]="isPestaniaSelected(pestIndex)">
          <div class="fb-tab__header" (click)="selectPestania(pestIndex)">
            <span class="fb-tab__handle" cdkDragHandle [title]="'FORM_BUILDER.DRAG_TAB' | translate"
                  (click)="$event.stopPropagation()">⠿</span>
            <span class="fb-tab__icon"><mat-icon>folder</mat-icon></span>
            <span class="fb-tab__name">
              {{ asFormGroup(pest).get('nombre')?.value || ('FORM_BUILDER.UNNAMED' | translate) }}
            </span>
            <span class="fb-tab__count">{{ camposOf(pestIndex).length }}</span>
            <button type="button" class="fb-chev"
                    (click)="togglePestaniaExpand(pestIndex); $event.stopPropagation()">
              {{ isPestaniaExpanded(pestIndex) ? '▾' : '▸' }}
            </button>
          </div>

          <div class="fb-tab__body"
               *ngIf="isPestaniaExpanded(pestIndex)"
               cdkDropList
               [id]="'campos-list-' + pestIndex"
               [cdkDropListData]="camposOfAsGroups(pestIndex)"
               [cdkDropListConnectedTo]="connectedCamposLists"
               (cdkDropListDropped)="onCampoDrop($event, pestIndex)">

            <div class="fb-field-row"
                 *ngFor="let campo of camposOf(pestIndex).controls; let campoIndex = index"
                 cdkDrag
                 [class.fb-field-row--selected]="isCampoSelected(pestIndex, campoIndex)"
                 (click)="selectCampo(pestIndex, campoIndex)">
              <span class="fb-field-row__handle" cdkDragHandle [title]="'FORM_BUILDER.DRAG' | translate">⠿</span>
              <span class="fb-field-row__chip">
                {{ getTipoAbbr(getCampoTipo(pestIndex, campoIndex)) }}
              </span>
              <span class="fb-field-row__label">
                {{ asFormGroup(campo).get('label')?.value
                   || asFormGroup(campo).get('nombre')?.value
                   || ('FORM_BUILDER.UNNAMED' | translate) }}
              </span>
              <span class="fb-field-row__req"
                    *ngIf="asFormGroup(campo).get('obligatorio')?.value">●</span>
            </div>

            <button type="button" class="fb-field-row fb-field-row--add"
                    (click)="addCampo(pestIndex)">
              {{ 'FORM_BUILDER.ADD_FIELD' | translate }}
            </button>
          </div>
        </div>
        </div>
      </div>

      <div class="fb-hint" *ngIf="currentStep === 2">
        {{ 'FORM_BUILDER.HINT2' | translate }}
      </div>
    </aside>

    <section class="fb-panel fb-panel--center">

      <div class="fb-center__content" [ngSwitch]="currentStep">

        <div *ngSwitchCase="0" class="fb-step0" [formGroup]="tramiteForm">

          <div class="fb-notice fb-notice--info">
            <div class="fb-notice__body">
              {{ 'FORM_BUILDER.NOTICE_REQ' | translate }}
            </div>
            <button type="button" class="fb-btn fb-btn--ghost fb-btn--sm" (click)="usarDatosDemo()">
              {{ 'FORM_BUILDER.DEMO' | translate }}
            </button>
          </div>

          <div class="fb-card">
            <div class="fb-card__header">{{ 'FORM_BUILDER.ID_CARD' | translate }}</div>
            <div class="fb-card__body">
              <div class="fb-row">
                <div class="fb-col fb-col--12">
                  <label class="fb-label" for="fb-nombre">
                    {{ 'FORM_BUILDER.TITLE' | translate }} <span class="fb-req">*</span>
                  </label>
                  <input id="fb-nombre" type="text" class="fb-input"
                         formControlName="nombre"
                         [placeholder]="'FORM_BUILDER.TITLE_PH' | translate">
                </div>

                <div class="fb-col fb-col--4">
                  <label class="fb-label" for="fb-codigo">
                    {{ 'FORM_BUILDER.CODE' | translate }} <span class="fb-req">*</span>
                  </label>
                  <input id="fb-codigo" type="text" class="fb-input"
                         formControlName="codigo"
                         [placeholder]="'FORM_BUILDER.CODE_PH' | translate">
                </div>

                <div class="fb-col fb-col--4">
                  <label class="fb-label" for="fb-identificador">{{ 'FORM_BUILDER.IDENT_MV' | translate }}</label>
                  <input id="fb-identificador" type="text" class="fb-input"
                         formControlName="identificador"
                         [placeholder]="'FORM_BUILDER.IDENT_PH' | translate">
                </div>

                <div class="fb-col fb-col--4">
                  <label class="fb-label" for="fb-sia">{{ 'FORM_BUILDER.SIA' | translate }}</label>
                  <input id="fb-sia" type="text" class="fb-input"
                         formControlName="sia"
                         [placeholder]="'FORM_BUILDER.SIA_PH' | translate">
                </div>

                <div class="fb-col fb-col--8" formGroupName="departamento">
                  <label class="fb-label" for="fb-departamento">
                    {{ 'FORM_BUILDER.DEPT' | translate }} <span class="fb-req">*</span>
                  </label>
                  <select id="fb-departamento" class="fb-input fb-select"
                          formControlName="id">
                    <option [ngValue]="null" disabled>{{ 'FORM_BUILDER.DEPT_PH' | translate }}</option>
                    <option *ngFor="let dep of departamentos" [ngValue]="dep.id">
                      {{ dep.nombre }}
                    </option>
                  </select>
                </div>

                <div class="fb-col fb-col--4 fb-col--align-end" *ngIf="!ocultarVisible">
                  <label class="fb-label">{{ 'FORM_BUILDER.VISIBLE' | translate }}</label>
                  <div class="fb-toggle">
                    <input type="checkbox" id="fb-visible" formControlName="visible">
                    <label for="fb-visible" class="fb-toggle__track">
                      <span class="fb-toggle__thumb"></span>
                    </label>
                    <span class="fb-toggle__text">
                      {{ tramiteForm.get('visible')?.value ? ('FORM_BUILDER.VISIBLE_YES' | translate) : ('FORM_BUILDER.VISIBLE_NO' | translate) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="fb-card">
            <div class="fb-card__header">{{ 'FORM_BUILDER.LINKS_DATES' | translate }}</div>
            <div class="fb-card__body">
              <div class="fb-row">
                <div class="fb-col fb-col--6">
                  <label class="fb-label" for="fb-link-ayuda">{{ 'FORM_BUILDER.LINK_HELP' | translate }}</label>
                  <input id="fb-link-ayuda" type="url" class="fb-input"
                         formControlName="link_ayuda"
                         placeholder="https://...">
                </div>
                <div class="fb-col fb-col--6">
                  <label class="fb-label" for="fb-link-ord">{{ 'FORM_BUILDER.LINK_ORD' | translate }}</label>
                  <input id="fb-link-ord" type="url" class="fb-input"
                         formControlName="link_ordenanza"
                         placeholder="https://...">
                </div>
                <div class="fb-col fb-col--6">
                  <label class="fb-label" for="fb-fecha-apertura">{{ 'FORM_BUILDER.DATE_OPEN' | translate }}</label>
                  <input id="fb-fecha-apertura" type="date" class="fb-input"
                         formControlName="fechaApertura">
                </div>
                <div class="fb-col fb-col--6">
                  <label class="fb-label" for="fb-fecha-cierre">{{ 'FORM_BUILDER.DATE_CLOSE' | translate }}</label>
                  <input id="fb-fecha-cierre" type="date" class="fb-input"
                         formControlName="fechaCierre">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngSwitchCase="1" class="fb-step1">

          <div *ngIf="selectionMode === 'none'" class="fb-placeholder">
            <h2>{{ 'FORM_BUILDER.SELECT_TAB' | translate }}</h2>
            <p>{{ 'FORM_BUILDER.SELECT_TAB_HINT' | translate }}</p>
            <div class="fb-placeholder__actions">
              <button type="button" class="fb-btn fb-btn--primary" (click)="addPestania()">
                + {{ 'FORM_BUILDER.NEW_TAB' | translate }}
              </button>
              <button type="button" class="fb-btn fb-btn--ghost" (click)="openCopiarPestania()">
                {{ 'FORM_BUILDER.COPY_OTHER' | translate }}
              </button>
            </div>
          </div>

          <div *ngIf="selectionMode === 'pestania' && selectedPestania as pestaniaForm"
               [formGroup]="pestaniaForm">
            <div class="fb-card">
              <div class="fb-card__header">{{ 'FORM_BUILDER.TAB_CONFIG' | translate }}</div>
              <div class="fb-card__body">
                <div class="fb-row">
                  <div class="fb-col fb-col--6">
                    <label class="fb-label">{{ 'COMMON.NAME' | translate }} <span class="fb-req">*</span></label>
                    <input type="text" class="fb-input" formControlName="nombre">
                  </div>
                  <div class="fb-col fb-col--6">
                    <label class="fb-label">{{ 'FORM_BUILDER.TAG_ID' | translate }} <span class="fb-req">*</span></label>
                    <input type="text" class="fb-input" formControlName="tagId"
                           [placeholder]="'FORM_BUILDER.TAG_PH' | translate">
                    <small class="fb-hint-text">{{ 'FORM_BUILDER.TAG_HINT' | translate }}</small>
                  </div>
                  <div class="fb-col fb-col--12">
                    <label class="fb-label">{{ 'FORM_BUILDER.VISIBLE_TITLE' | translate }}</label>
                    <input type="text" class="fb-input" formControlName="titulo">
                  </div>
                </div>
              </div>
            </div>
            <div class="fb-notice fb-notice--info">
              {{ 'FORM_BUILDER.ADD_FIELDS_HINT' | translate }}
            </div>
          </div>

          <div *ngIf="selectionMode === 'campo' && selectedCampo as campoForm"
               [formGroup]="campoForm" class="fb-campo-config">

            <div class="fb-card">
              <div class="fb-card__header">{{ 'FORM_BUILDER.FIELD_TYPE' | translate }}</div>
              <div class="fb-card__body">
                <div class="fb-type-grid">
                  <button type="button"
                          *ngFor="let t of tiposCampo"
                          class="fb-type-pill"
                          [class.fb-type-pill--active]="campoForm.get('tipo')?.value === t.value"
                          [attr.title]="('FORM_BUILDER.TIPO_DESC.' + t.value) | translate"
                          (click)="setCampoTipo(t.value)">
                    <span class="fb-type-pill__icon"><mat-icon>{{ t.icon }}</mat-icon></span>
                    <span class="fb-type-pill__label">{{ ('FORM_BUILDER.TIPO.' + t.value) | translate }}</span>
                  </button>
                </div>
              </div>
            </div>

            <div class="fb-card">
              <div class="fb-card__header">{{ 'FORM_BUILDER.FIELD_ID' | translate }}</div>
              <div class="fb-card__body">
                <div class="fb-row">
                  <div class="fb-col fb-col--6">
                    <label class="fb-label">{{ 'FORM_BUILDER.LABEL' | translate }}</label>
                    <input type="text" class="fb-input" formControlName="label">
                    <small class="fb-hint-text">{{ 'FORM_BUILDER.LABEL_HINT' | translate }}</small>
                  </div>
                  <div class="fb-col fb-col--6">
                    <label class="fb-label">{{ 'FORM_BUILDER.TECH_NAME' | translate }} <span class="fb-req">*</span></label>
                    <input type="text" class="fb-input" formControlName="nombre">
                    <small class="fb-hint-text">{{ 'FORM_BUILDER.TECH_HINT' | translate }}</small>
                  </div>
                  <div class="fb-col fb-col--12"
                       *ngIf="campoForm.get('tipo')?.value === 'checkbox'">
                    <label class="fb-label">{{ 'FORM_BUILDER.CHECKBOX_TEXT' | translate }}</label>
                    <textarea class="fb-input" rows="3"
                              formControlName="textoRepresentativo"></textarea>
                  </div>
                  <div class="fb-col fb-col--6">
                    <label class="fb-label">{{ 'FORM_BUILDER.EMPH_TITLE' | translate }}</label>
                    <input type="text" class="fb-input" formControlName="tituloEnfatizado"
                           [placeholder]="'FORM_BUILDER.EMPH_PH' | translate">
                  </div>
                  <div class="fb-col fb-col--6">
                    <label class="fb-label">{{ 'FORM_BUILDER.WIDTH' | translate }}</label>
                    <select class="fb-input fb-select" formControlName="divClass">
                      <option *ngFor="let d of divClassOptions" [value]="d.value">
                        {{ ('FORM_BUILDER.WIDTH_OPT.' + d.key) | translate }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="fb-card">
              <div class="fb-card__header">{{ 'FORM_BUILDER.BEHAVIOR' | translate }}</div>
              <div class="fb-card__body">
                <div class="fb-row">
                  <div class="fb-col fb-col--6">
                    <div class="fb-toggle">
                      <input type="checkbox" id="fb-obligatorio" formControlName="obligatorio">
                      <label for="fb-obligatorio" class="fb-toggle__track">
                        <span class="fb-toggle__thumb"></span>
                      </label>
                      <span class="fb-toggle__text">{{ 'FORM_BUILDER.REQUIRED' | translate }}</span>
                    </div>
                  </div>
                  <div class="fb-col fb-col--6">
                    <div class="fb-toggle">
                      <input type="checkbox" id="fb-habilitado" formControlName="habilitado">
                      <label for="fb-habilitado" class="fb-toggle__track">
                        <span class="fb-toggle__thumb"></span>
                      </label>
                      <span class="fb-toggle__text">{{ 'FORM_BUILDER.ENABLED' | translate }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="fb-card" *ngIf="showValidation(campoForm.get('tipo')?.value)">
              <div class="fb-card__header">{{ 'FORM_BUILDER.VALIDATION' | translate }}</div>
              <div class="fb-card__body">
                <div class="fb-row">
                  <div class="fb-col fb-col--6">
                    <label class="fb-label">{{ 'FORM_BUILDER.VALIDATOR' | translate }}</label>
                    <select class="fb-input fb-select" formControlName="tipovalidador">
                      <option *ngFor="let v of validadores" [value]="v.value">{{ validatorLabel(v) }}</option>
                    </select>
                  </div>
                  <div class="fb-col fb-col--6"
                       *ngIf="campoForm.get('tipovalidador')?.value === 'Pattern'">
                    <label class="fb-label">{{ 'FORM_BUILDER.REGEX' | translate }}</label>
                    <input type="text" class="fb-input" formControlName="patternvalidador"
                           placeholder="^[A-Za-z0-9]+$">
                  </div>
                </div>
              </div>
            </div>

            <div class="fb-card" *ngIf="showPrecarga(campoForm.get('tipo')?.value)">
              <div class="fb-card__header">{{ 'FORM_BUILDER.PRELOAD' | translate }}</div>
              <div class="fb-card__body">
                <div class="fb-row">
                  <div class="fb-col fb-col--6">
                    <label class="fb-label">{{ 'FORM_BUILDER.BEAN' | translate }}</label>
                    <input type="text" class="fb-input" formControlName="nombreVariableDefecto"
                           [placeholder]="'FORM_BUILDER.BEAN_PH' | translate">
                  </div>
                  <div class="fb-col fb-col--6">
                    <label class="fb-label">{{ 'FORM_BUILDER.BEAN_FIELD' | translate }}</label>
                    <input type="text" class="fb-input" formControlName="nombreCampoDefecto"
                           [attr.disabled]="!campoForm.get('nombreVariableDefecto')?.value ? '' : null">
                  </div>
                </div>
              </div>
            </div>

            <div class="fb-card" *ngIf="showOpciones(campoForm.get('tipo')?.value)">
              <div class="fb-card__header">{{ 'FORM_BUILDER.OPTIONS' | translate }}</div>
              <div class="fb-card__body">

                <div class="fb-notice fb-notice--info">
                  <div class="fb-notice__body">
                    {{ 'FORM_BUILDER.OPTIONS_NOTICE' | translate }}
                  </div>
                </div>

                <div class="fb-row">
                  <div class="fb-col fb-col--12">
                    <label class="fb-label">
                      {{ 'FORM_BUILDER.LISTADO' | translate }} <span class="fb-req">*</span>
                    </label>
                    <select class="fb-input"
                            [ngModel]="campoForm.get('listado')?.value || ''"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="onListadoExistenteSelected($event)">
                      <option value="" disabled>{{ 'FORM_BUILDER.LISTADO_PH' | translate }}</option>
                      <option *ngFor="let l of listadosDisponibles" [value]="l">{{ l }}</option>
                    </select>
                    <small class="fb-hint" *ngIf="!campoForm.get('listado')?.value">
                      {{ 'FORM_BUILDER.LISTADO_HINT' | translate }}
                    </small>
                  </div>
                </div>

                <div class="fb-opciones-readonly"
                     *ngIf="opcionesDelCampoSeleccionado && opcionesDelCampoSeleccionado.length > 0">
                  <div class="fb-opciones-readonly__title">
                    {{ 'FORM_BUILDER.OPTIONS_LOADED' | translate:{count: opcionesDelCampoSeleccionado.length} }}
                  </div>
                  <div class="fb-opcion-readonly"
                       *ngFor="let op of opcionesDelCampoSeleccionado.controls">
                    <span class="fb-opcion-readonly__valor">{{ op.get('valor')?.value }}</span>
                    <span class="fb-opcion-readonly__sep">·</span>
                    <span class="fb-opcion-readonly__label">{{ op.get('label')?.value }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngSwitchCase="2" class="fb-step2">
          <div class="fb-notice fb-notice--warning" *ngIf="!ocultarVisible && tramiteForm.get('visible')?.value">
            <div class="fb-notice__body">
              {{ 'FORM_BUILDER.VISIBLE_WARN' | translate }}
            </div>
          </div>

          <div class="fb-card">
            <div class="fb-card__header">{{ 'FORM_BUILDER.STEP.DATOS' | translate }}</div>
            <div class="fb-card__body">
              <dl class="fb-review__meta">
                <dt>{{ 'FORM_BUILDER.REVIEW_NAME' | translate }}</dt><dd>{{ previewData.nombre || '—' }}</dd>
                <dt>{{ 'FORM_BUILDER.REVIEW_CODE' | translate }}</dt><dd>{{ previewData.codigo || '—' }}</dd>
                <dt>{{ 'FORM_BUILDER.REVIEW_DEPT' | translate }}</dt><dd>{{ previewData.departamentoNombre || '—' }}</dd>
                <dt>{{ 'FORM_BUILDER.REVIEW_IDENT' | translate }}</dt><dd>{{ previewData.identificador || '—' }}</dd>
                <dt>{{ 'FORM_BUILDER.REVIEW_SIA' | translate }}</dt><dd>{{ previewData.sia || '—' }}</dd>
                <dt>{{ 'FORM_BUILDER.REVIEW_VISIBLE' | translate }}</dt>
                <dd>
                  <span class="fb-badge"
                        [class.fb-badge--success]="previewData.visible"
                        [class.fb-badge--muted]="!previewData.visible">
                    {{ previewData.visible ? ('COMMON.YES' | translate) : ('COMMON.NO' | translate) }}
                  </span>
                </dd>
                <ng-container *ngIf="previewData.linkAyuda">
                  <dt>{{ 'FORM_BUILDER.REVIEW_HELP' | translate }}</dt><dd>{{ previewData.linkAyuda }}</dd>
                </ng-container>
                <ng-container *ngIf="previewData.linkOrdenanza">
                  <dt>{{ 'FORM_BUILDER.REVIEW_ORD' | translate }}</dt><dd>{{ previewData.linkOrdenanza }}</dd>
                </ng-container>
                <ng-container *ngIf="previewData.fechaApertura">
                  <dt>{{ 'FORM_BUILDER.REVIEW_OPEN' | translate }}</dt><dd>{{ previewData.fechaApertura }}</dd>
                </ng-container>
                <ng-container *ngIf="previewData.fechaCierre">
                  <dt>{{ 'FORM_BUILDER.REVIEW_CLOSE' | translate }}</dt><dd>{{ previewData.fechaCierre }}</dd>
                </ng-container>
              </dl>
            </div>
          </div>

          <div class="fb-card"
               *ngFor="let pest of pestanias.controls; let pIdx = index">
            <div class="fb-card__header">
              <mat-icon>folder</mat-icon> {{ asFormGroup(pest).get('nombre')?.value || ('FORM_BUILDER.TAB_N' | translate:{n: pIdx + 1}) }}
              <span class="fb-tab__count fb-card__count">
                {{ camposOf(pIdx).length }}
              </span>
            </div>
            <div class="fb-card__body">
              <div *ngIf="camposOf(pIdx).length === 0" class="fb-muted">
                {{ 'FORM_BUILDER.TAB_EMPTY' | translate }}
              </div>
              <ul class="fb-review__campos" *ngIf="camposOf(pIdx).length > 0">
                <li class="fb-review__campo"
                    *ngFor="let campo of camposOf(pIdx).controls">
                  <span class="fb-field-row__chip">
                    {{ getTipoAbbr(asFormGroup(campo).get('tipo')?.value || '') }}
                  </span>
                  <span class="fb-review__campo-name">
                    {{ asFormGroup(campo).get('label')?.value
                       || asFormGroup(campo).get('nombre')?.value
                       || '—' }}
                  </span>
                  <span class="fb-badge fb-badge--danger"
                        *ngIf="asFormGroup(campo).get('obligatorio')?.value">OBL</span>
                </li>
              </ul>
            </div>
          </div>

          <div *ngIf="pestanias.length === 0" class="fb-placeholder">
            <p>{{ 'FORM_BUILDER.NO_TABS_CFG' | translate }}</p>
          </div>
        </div>
      </div>

      <div class="fb-actionbar">
        <button class="fb-btn fb-btn--ghost"
                [disabled]="currentStep === 0"
                (click)="prevStep()">
          ← {{ 'COMMON.BACK' | translate }}
        </button>

        <ng-container *ngIf="currentStep === 1">
          <button type="button" class="fb-btn fb-btn--danger"
                  *ngIf="selectionMode === 'pestania'"
                  (click)="deleteSelectedPestania()">
            {{ 'FORM_BUILDER.DELETE_TAB' | translate }}
          </button>
          <button type="button" class="fb-btn fb-btn--danger"
                  *ngIf="selectionMode === 'campo'"
                  (click)="deleteSelectedCampo()">
            {{ 'FORM_BUILDER.DELETE_FIELD' | translate }}
          </button>
        </ng-container>

        <div class="fb-actionbar__spacer"></div>

        <button class="fb-btn fb-btn--primary"
                *ngIf="currentStep < 2"
                [disabled]="currentStep === 0 && !canAdvanceFromStep0"
                (click)="nextStep()">
          {{ currentStep === 1 ? ('FORM_BUILDER.NEXT_REVIEW' | translate) : ('FORM_BUILDER.NEXT' | translate) }}
        </button>
        <button class="fb-btn fb-btn--success"
                *ngIf="currentStep === 2"
                [disabled]="saving"
                (click)="saveTramite()">
           <mat-icon>save</mat-icon> {{ saving ? ('FORM_BUILDER.SAVING' | translate) : ('FORM_BUILDER.SAVE' | translate) }}
        </button>
      </div>
    </section>

    <aside class="fb-panel fb-panel--right">
      <div class="fb-preview__tabs">
        <button class="fb-preview__tab"
                [class.fb-preview__tab--active]="previewMode === 'form'"
                (click)="setPreviewMode('form')">{{ 'FORM_BUILDER.PREVIEW_FORM' | translate }}</button>
        <button class="fb-preview__tab"
                [class.fb-preview__tab--active]="previewMode === 'mobile'"
                (click)="setPreviewMode('mobile')">{{ 'FORM_BUILDER.PREVIEW_MOBILE' | translate }}</button>
        <button class="fb-preview__tab"
                [class.fb-preview__tab--active]="previewMode === 'json'"
                (click)="setPreviewMode('json')">{{ 'FORM_BUILDER.PREVIEW_JSON' | translate }}</button>
        <div class="fb-preview__tabs-spacer"></div>
        <button type="button" class="fb-preview__expand"
                [title]="'FORM_BUILDER.EXPAND' | translate"
                (click)="openExpandedPreview()">⤢</button>
      </div>

      <div class="fb-preview__body">

        <div *ngIf="previewMode === 'form'" class="fb-preview__form">
          <ng-container
            *ngTemplateOutlet="formPreviewTpl; context: { scale: 1 }"></ng-container>
        </div>

        <div *ngIf="previewMode === 'mobile'" class="fb-preview__mobile">
          <div class="fb-phone">
            <div class="fb-phone__notch"></div>
            <div class="fb-phone__screen">
              <ng-container
                *ngTemplateOutlet="formPreviewTpl; context: { scale: 0.6 }"></ng-container>
            </div>
          </div>
        </div>

        <div *ngIf="previewMode === 'json'" class="fb-preview__json">
          <div class="fb-preview__json-actions">
            <button type="button" class="fb-btn fb-btn--ghost fb-btn--sm"
                    (click)="copyPreviewJson()">
              {{ jsonCopied ? ('COMMON.COPIED' | translate) : ('COMMON.COPY' | translate) }}
            </button>
            <button type="button" class="fb-btn fb-btn--ghost fb-btn--sm"
                    (click)="downloadPreviewJson()">{{ 'FORM_BUILDER.DOWNLOAD_JSON' | translate }}</button>
          </div>
          <pre class="fb-preview__json-code">{{ previewJson }}</pre>
        </div>
      </div>

      <!-- Plantilla compartida: formulario + móvil ---------- -->
      <ng-template #formPreviewTpl let-scale="scale">
        <div class="fb-tramite-preview" [style.font-size.px]="scale === 1 ? 13 : 10">
          <h5 class="fb-tramite-preview__title">
            {{ previewData.nombre || ('FORM_BUILDER.PREVIEW_TITLE_PH' | translate) }}
          </h5>

          <div class="fb-tramite-preview__tabs" *ngIf="pestanias.length > 0">
            <a class="fb-tramite-preview__tab"
               *ngFor="let pest of pestanias.controls; let i = index"
               [class.fb-tramite-preview__tab--active]="isPreviewTabActive(i)"
               (click)="selectPreviewTab(i)">
              {{ asFormGroup(pest).get('nombre')?.value || ('FORM_BUILDER.TAB_N' | translate:{n: i + 1}) }}
            </a>
          </div>

          <div class="fb-tramite-preview__pane"
               *ngIf="pestanias.length > 0 && pestaniaAt(previewActiveTabIndex) as activePest">
            <h3 class="fb-tramite-preview__tabtitle"
                *ngIf="activePest.get('titulo')?.value">
              {{ activePest.get('titulo')?.value }}
            </h3>

            <div class="fb-tramite-preview__row">
              <div class="fb-tramite-preview__field"
                   *ngFor="let campo of camposOf(previewActiveTabIndex).controls"
                   [ngClass]="asFormGroup(campo).get('divClass')?.value || 'col-sm-12'">

                <ng-container *ngIf="asFormGroup(campo).get('tituloEnfatizado')?.value">
                  <div class="fb-tramite-preview__emph">
                    {{ asFormGroup(campo).get('tituloEnfatizado')?.value }}
                  </div>
                </ng-container>

                <label class="fb-tramite-preview__label"
                       *ngIf="asFormGroup(campo).get('tipo')?.value !== 'checkbox'">
                  {{ asFormGroup(campo).get('label')?.value
                     || (asFormGroup(campo).get('nombre')?.value + ' ' + ('FORM_BUILDER.TECH_NOT_VISIBLE' | translate)) }}
                  <span class="fb-tramite-preview__mandatory"
                        *ngIf="asFormGroup(campo).get('obligatorio')?.value">*</span>
                </label>

                <ng-container [ngSwitch]="asFormGroup(campo).get('tipo')?.value">
                  <input *ngSwitchCase="'text'" type="text" class="fb-tramite-preview__input"
                         disabled>
                  <input *ngSwitchCase="'number'" type="number" class="fb-tramite-preview__input"
                         disabled>
                  <input *ngSwitchCase="'email'" type="email" class="fb-tramite-preview__input"
                         disabled>
                  <input *ngSwitchCase="'date'" type="date" class="fb-tramite-preview__input"
                         disabled>
                  <textarea *ngSwitchCase="'textarea'" class="fb-tramite-preview__input"
                            rows="3" disabled></textarea>
                  <input *ngSwitchCase="'file'" type="file" class="fb-tramite-preview__input"
                         disabled>

                  <select *ngSwitchCase="'select'" class="fb-tramite-preview__input" disabled>
                    <option *ngFor="let op of opcionesOfCampo(campo)">
                      {{ op.get('label')?.value }}
                    </option>
                  </select>

                  <select *ngSwitchCase="'multiselect'" class="fb-tramite-preview__input"
                          multiple disabled>
                    <option *ngFor="let op of opcionesOfCampo(campo)">
                      {{ op.get('label')?.value }}
                    </option>
                  </select>

                  <label *ngSwitchCase="'checkbox'" class="fb-tramite-preview__checkbox">
                    <input type="checkbox" disabled>
                    <span class="fb-tramite-preview__checkbox-text">
                      <ng-container
                        *ngIf="asFormGroup(campo).get('textoRepresentativo')?.value; else plainCheckboxLabel">
                        <span [innerHTML]="asFormGroup(campo).get('textoRepresentativo')?.value"></span>
                      </ng-container>
                      <ng-template #plainCheckboxLabel>
                        {{ asFormGroup(campo).get('label')?.value
                           || asFormGroup(campo).get('nombre')?.value }}
                      </ng-template>
                      <span class="fb-tramite-preview__mandatory"
                            *ngIf="asFormGroup(campo).get('obligatorio')?.value">*</span>
                    </span>
                  </label>
                </ng-container>
              </div>
            </div>

            <div class="fb-tramite-preview__buttons">
              <button type="button" class="fb-tramite-preview__btn fb-tramite-preview__btn--danger">
                {{ 'COMMON.CANCEL' | translate }}
              </button>
              <button type="button" class="fb-tramite-preview__btn">{{ 'COMMON.BACK' | translate }}</button>
              <button type="button" class="fb-tramite-preview__btn fb-tramite-preview__btn--primary">
                {{ 'COMMON.NEXT' | translate }}
              </button>
            </div>
          </div>

          <div class="fb-preview__stub" *ngIf="pestanias.length === 0">
            {{ 'FORM_BUILDER.PREVIEW_EMPTY' | translate }}
          </div>
        </div>
      </ng-template>
    </aside>

  </div>

  <div class="fb-copytab-modal" *ngIf="copiandoPestania"
       (click)="closeCopiarPestania()">
    <div class="fb-copytab-modal__dialog" (click)="$event.stopPropagation()">
      <div class="fb-copytab-modal__header">
        <span class="fb-copytab-modal__title">{{ 'FORM_BUILDER.COPY_TAB' | translate }}</span>
        <button type="button" class="fb-preview-modal__close" [title]="'COMMON.CLOSE_ESC' | translate"
                (click)="closeCopiarPestania()">✕</button>
      </div>
      <div class="fb-copytab-modal__body">
        <label class="fb-label" for="fb-tramite-origen">{{ 'FORM_BUILDER.ORIGIN' | translate }}</label>
        <select id="fb-tramite-origen" class="fb-input"
                (change)="onTramiteOrigenSelected($any($event.target).value)">
          <option value="" [selected]="tramiteOrigenId === null" disabled>
            {{ 'FORM_BUILDER.ORIGIN_PH' | translate }}
          </option>
          <option *ngFor="let t of tramitesOrigen" [value]="t.id"
                  [selected]="tramiteOrigenId === t.id">
            {{ t.nombre }}{{ t.codigo ? ' (' + t.codigo + ')' : '' }}
          </option>
        </select>

        <div class="fb-copytab-modal__loading" *ngIf="cargandoPestaniasOrigen">
          {{ 'FORM_BUILDER.LOADING_TABS' | translate }}
        </div>

        <div class="fb-copytab-modal__list" *ngIf="pestaniasOrigen.length > 0">
          <div class="fb-copytab-modal__group" *ngFor="let p of pestaniasOrigen; let i = index">
            <div class="fb-copytab-modal__item"
                 [title]="'FORM_BUILDER.VIEW_FIELDS' | translate"
                 (click)="toggleOrigenExpand(i)">
              <span class="fb-chev">{{ isOrigenExpanded(i) ? '▾' : '▸' }}</span>
              <mat-icon>folder</mat-icon>
              <span class="fb-copytab-modal__name">{{ p.nombre || ('FORM_BUILDER.UNNAMED' | translate) }}</span>
              <span class="fb-tab__count">{{ p.campos?.length || 0 }}</span>
              <button type="button" class="fb-copytab-modal__copy"
                      [title]="'FORM_BUILDER.COPY_TO_CURRENT' | translate"
                      (click)="copiarPestaniaOrigen(p); $event.stopPropagation()">
                <mat-icon>content_copy</mat-icon>
              </button>
            </div>

            <div class="fb-copytab-modal__fields" *ngIf="isOrigenExpanded(i)">
              <div class="fb-copytab-modal__field" *ngFor="let c of camposOrdenadosDe(p)">
                <span class="fb-field-row__chip">{{ getTipoAbbr(c.tipo) }}</span>
                <span class="fb-copytab-modal__fieldname">
                  {{ c.label || c.nombre || ('FORM_BUILDER.UNNAMED' | translate) }}
                </span>
                <span class="fb-field-row__req" *ngIf="c.obligatorio">●</span>
              </div>
              <p class="fb-copytab-modal__empty" *ngIf="(p.campos?.length || 0) === 0">
                {{ 'FORM_BUILDER.TAB_EMPTY' | translate }}
              </p>
            </div>
          </div>
        </div>

        <p class="fb-copytab-modal__empty"
           *ngIf="tramiteOrigenId !== null && !cargandoPestaniasOrigen && pestaniasOrigen.length === 0">
          {{ 'FORM_BUILDER.ORIGIN_NO_TABS' | translate }}
        </p>

        <p class="fb-copytab-modal__hint">
          {{ 'FORM_BUILDER.COPY_HINT' | translate }}
        </p>
      </div>
    </div>
  </div>

  <div class="fb-preview-modal" *ngIf="previewExpanded"
       (click)="closeExpandedPreview()">
    <div class="fb-preview-modal__dialog" (click)="$event.stopPropagation()">
      <div class="fb-preview-modal__header">
        <div class="fb-preview-modal__tabs">
          <button class="fb-preview__tab"
                  [class.fb-preview__tab--active]="previewMode === 'form'"
                  (click)="setPreviewMode('form')">{{ 'FORM_BUILDER.PREVIEW_FORM' | translate }}</button>
          <button class="fb-preview__tab"
                  [class.fb-preview__tab--active]="previewMode === 'mobile'"
                  (click)="setPreviewMode('mobile')">{{ 'FORM_BUILDER.PREVIEW_MOBILE' | translate }}</button>
          <button class="fb-preview__tab"
                  [class.fb-preview__tab--active]="previewMode === 'json'"
                  (click)="setPreviewMode('json')">{{ 'FORM_BUILDER.PREVIEW_JSON' | translate }}</button>
        </div>
        <button type="button" class="fb-preview-modal__close"
                [title]="'COMMON.CLOSE_ESC' | translate"
                (click)="closeExpandedPreview()">✕</button>
      </div>

      <div class="fb-preview-modal__body">
        <div *ngIf="previewMode === 'form'" class="fb-preview-modal__form">
          <ng-container
            *ngTemplateOutlet="formPreviewTpl; context: { scale: 1.4 }"></ng-container>
        </div>

        <div *ngIf="previewMode === 'mobile'" class="fb-preview-modal__mobile">
          <div class="fb-phone fb-phone--lg">
            <div class="fb-phone__notch"></div>
            <div class="fb-phone__screen">
              <ng-container
                *ngTemplateOutlet="formPreviewTpl; context: { scale: 1 }"></ng-container>
            </div>
          </div>
        </div>

        <div *ngIf="previewMode === 'json'" class="fb-preview-modal__json">
          <div class="fb-preview__json-actions">
            <button type="button" class="fb-btn fb-btn--ghost fb-btn--sm"
                    (click)="copyPreviewJson()">
              {{ jsonCopied ? ('COMMON.COPIED' | translate) : ('COMMON.COPY' | translate) }}
            </button>
            <button type="button" class="fb-btn fb-btn--ghost fb-btn--sm"
                    (click)="downloadPreviewJson()">{{ 'FORM_BUILDER.DOWNLOAD_JSON' | translate }}</button>
          </div>
          <pre class="fb-preview__json-code fb-preview__json-code--lg">{{ previewJson }}</pre>
        </div>
      </div>
    </div>
  </div>
</div>
